import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import i18n from 'simple-react-i18n'
import { formatIndicatorCount, getCountPercent } from '../utils/RPQSUtils'

const IndicatorCountSummary = ({ count = { filled: 0, required: 0 } }) => (
    <Box sx={{ textAlign: 'right' }}>
        <Typography color='text.secondary'>{i18n.rpqsFilledIndicatorsTotal}</Typography>
        <Typography variant='h5' fontWeight='bold'>
            {`${formatIndicatorCount(count)} (${getCountPercent(count)}%)`}
        </Typography>
    </Box>
)

IndicatorCountSummary.propTypes = {
    count: PropTypes.shape({
        filled: PropTypes.number,
        required: PropTypes.number,
    }),
}

export default IndicatorCountSummary
